import { FC } from 'react';

import { CloseButton, Button } from '../../shared/ui';

export interface GroupConnectionRequestNotificationProps {
  displayName: string;
  onAccept: () => void;
  onDismiss: () => void;
}

/**
 * Карточка уведомления для психолога: один клиент ожидает разрешение на подключение к конференции.
 * Отображается справа снизу, может наслаиваться с другими такими же карточками.
 */
export const GroupConnectionRequestNotification: FC<GroupConnectionRequestNotificationProps> = ({
  displayName,
  onAccept,
  onDismiss,
}) => (
  <div className="flex flex-col w-[400px] max-w-[calc(100vw - 32px)] gap-2 rounded-control bg-ink text-white p-4 shadow-overlay">
    <div className="flex items-start justify-between">
      <p className="text-body-l-strong leading-tight">Клиент ожидает разрешения</p>
      <CloseButton tone="inverse" className="flex-shrink-0 -m-1" onClick={onDismiss} />
    </div>
    <p className="text-ui font-normal text-white">Клиент {displayName} ожидает подключение к конференции.</p>
    <div className="flex justify-end gap-2 flex-wrap">
      <Button type="button" size="md" variant="ghostInverse" onClick={onDismiss}>
        Скрыть
      </Button>
      <Button type="button" size="md" onClick={onAccept}>
        Принять запрос
      </Button>
    </div>
  </div>
);
